import api from "./api";

const TaskService = {
    listTaskLists: (params = {}) => api.get("/api/task-lists/", { params }),
    list: (params = {}) => api.get("/api/tasks/", { params }),
    create: (data) => api.post("/api/tasks/", data),
    update: (id, data) => api.patch(`/api/tasks/${id}/`, data),
    remove: (id) => api.delete(`/api/tasks/${id}/`),
    refreshFocus: () => api.post("/api/tasks/refresh_focus/"),
    uploadAttachment: (file) => {
        const formData = new FormData();
        formData.append("document", file);
        formData.append("title", file.name);
        return api.post("/api/dropbox/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
    createSubTask: (taskId, data) =>
        api.post("/api/subtasks/", { ...data, task: taskId }),
    updateSubTask: (id, data) => api.patch(`/api/subtasks/${id}/`, data),
    deleteSubTask: (id) => api.delete(`/api/subtasks/${id}/`),
};

export default TaskService;
